import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { ServerBaseService } from '../server-base.service';
import { BehaviorSubject } from 'rxjs';
import { Dispatch, DispatchDeadline } from '@equipmyschool/emsadminweb-models';

@Injectable()
export class DispatchService extends ServerBaseService {
  private _dispatch$ = new BehaviorSubject<Dispatch>(null);
  private _deadlines$ = new BehaviorSubject<DispatchDeadline[]>([]);

  public dispatch$ = this._dispatch$.asObservable();
  public deadlines$ = this._deadlines$.asObservable();

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl);
  }

  getDispatch(dispatchId: number) {
    this.request<Dispatch>('GET', 'Dispatch/Get', {DispatchID: dispatchId})
      .subscribe({
        next: (data) => {
          this._dispatch$.next(data);
          this.getDeadlines(data.DispatchID);
        }
      });
  }

  getDeadlines(dispatchId: number) {
    this.request<DispatchDeadline[]>('GET', 'Dispatch/GetDeadlines', {DispatchID: dispatchId})
      .subscribe({
        next: (data) => {
          this._deadlines$.next(data);
        }
      });
  }

  checkRemainingLines(lineId: number) {
    this.request<void>('GET', 'Dispatch/CheckRemainingLines', {LineID: lineId})
      .subscribe();
  }
}
